import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {SellableSearchPageComponent} from "../sellable-search-page/sellable-search-page.component";
import {SellableSearchModel} from "../sellable-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-sellable-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(SellableSearchModel),
        registerSearchControl(SellableMultiSelectSearchControlComponent)
    ]
})
export class SellableMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<SellableSearchModel> {
    constructor(model: SellableSearchModel, injector: Injector) {
        super(model, injector, "sellableId", "name");
        this.extendedSearchComponent = SellableSearchPageComponent;
    }
}
